import { forwardRef } from "react";
import { t, font } from "@realtyflows/ui";

const variants = {
  error: { bg: `${t.coral}10`, border: `${t.coral}40`, color: t.coral, icon: "\u26A0" },
  warning: { bg: `${t.amber}12`, border: `${t.amber}40`, color: t.amber, icon: "\u26A0" },
  success: { bg: `${t.emerald}10`, border: `${t.emerald}40`, color: t.emerald, icon: "\u2714" },
  info: { bg: `${t.sky}10`, border: `${t.sky}40`, color: t.sky, icon: "\u2139" },
};

const Alert = forwardRef(function Alert({ message, variant = "error", onDismiss, style }, ref) {
  if (!message) return null;
  const v = variants[variant] || variants.error;
  return (
    <div ref={ref} style={{
      background: v.bg, border: `1px solid ${v.border}`, borderRadius: 8,
      padding: "10px 14px", display: "flex", alignItems: "center", gap: 10, ...style,
    }}>
      <span style={{ fontSize: 16, flexShrink: 0 }}>{v.icon}</span>
      <span style={{ fontSize: 13, color: v.color, fontWeight: 600, fontFamily: font.body, flex: 1 }}>{message}</span>
      {onDismiss && (
        <span onClick={onDismiss} style={{ cursor: "pointer", color: v.color, fontSize: 18, fontWeight: 700, lineHeight: 1, flexShrink: 0 }}>&times;</span>
      )}
    </div>
  );
});

export default Alert;
